import axios from "axios";

export const fetchUserData = async (token) => {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/v1/user/me/`,
      { headers }
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.error);
  }
};
